export default class LocalStorageKeys {
    static get id() {
        return "applicantid";
    }
    static get seriesSelection() {
        return "applicantseries";
    }
    static get packageSelection() {
        return "applicantpackage";
    }
    static get vehicleDataExists() {
        return "vehicledata_exists";
    }
    static get loginType() {
        return "logintype";
    }
    static get conciergeCode() {
        return "conciergeCode";
    }
    static get prevAuthCode() {
        return "previousAuthCode";
    }
    static get isLiquid() {
        return "PiBby_typeUwU_detect";
    }
    static get versionNumber() {
        return "version_number";
    }
}
